import React from 'react';
import { useSelector } from 'react-redux';

import NotAuthorized from './NotAuthorized';
import { READ, WRITE } from '../../services/users/permissionTypes';

const Permission = ({
  children,
  permissions,
}: {
  children: JSX.Element;
  permissions: string[];
}): JSX.Element => {
  const currentUser = useSelector((state: any) => state.users.current);
  const anyWritePermission =
    currentUser.allowedToWriteConfigurations ||
    currentUser.allowedToWriteOrganizationUnitProjects;

  const anyReadPermission =
    currentUser.allowedToReadConfigurations ||
    currentUser.allowedToWriteConfigurations ||
    currentUser.allowedToWriteOrganizationUnitProjects;

  if (permissions.includes(READ) && anyReadPermission) {
    return children;
  }

  if (permissions.includes(WRITE) && anyWritePermission) {
    return children;
  }

  return <NotAuthorized />;
};

export default Permission;
